// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9ac54044","235":"0fc88164","239":"67f8a13b","363":"ccb4ab6e","453":"546897bb","732":"b9cc8f9c","807":"1b95974b","855":"c69c5998"}[chunkId] + ".chunk.js";
};